module.exports = __webpack_public_path__ + "img/h_6.44dcad2f.png";